import type { CampaignDetail } from '~~/shared/types/models'
import { parseIsoDate } from '~~/shared/utils/date'

export function useCampaignStatus(campaign: CampaignListItem | null) {
  if (!campaign)
    return 'ended'

  const now = new Date()
  const start = parseIsoDate(campaign.startAt)
  const end = parseIsoDate(campaign.endAt)

  if (start && start > now)
    return 'upcoming'
  if (end && end < now)
    return 'ended'
  if (campaign.isOpen)
    return 'ongoing'
  return 'ended'
}
